<template>
  <b-modal
    ref="changeDevices"
    centered
    size="md"
    title="Change devices limit"
    hide-header-close
    scrollable
    footer-bg-variant=""
    @show="applyCurrentDevices()"
    @hidden="unselectUser(), clearCurrentDevices()">

    <b-form-group
      label="Total Devices"
      label-for="total-devices">
      <b-form-input
        type="number"
        min="1"
        id="total-devices"
        name="name-input"
        v-model.number="totalDevices"
        placeholder="5000"
        oninput="this.value = Math.abs(this.value)"
        @input="watchForInput" />
    </b-form-group>

    <div class="font-weight-bold mb-2">User Details</div>
    <b-list-group
      v-if="selectedUserId !== null"
      class="mb-0">
      <b-list-group-item class="d-flex align-items-center">
        User ID
        <b-badge
          variant="light"
          class="ml-auto font-size-xs">{{ selectedUser.code }}</b-badge>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Reseller ID
        <span class="ml-auto">{{ selectedUser.item_id }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Devices
        <span class="ml-auto">{{ selectedUser.devices }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Created
        <span class="ml-auto">{{ selectedUser.created | moment("DD.MM.YYYY, HH:mm") }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Expiry
        <span class="ml-auto">{{ selectedUser.expiry | moment("DD.MM.YYYY, HH:mm") }}</span>
      </b-list-group-item>
    </b-list-group>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('changeDevices')">
          Cancel
        </b-button>
        <b-button
          variant="primary"
          size="md"
          class="ml-auto"
          :disabled="usersResponses('changeUserDevices') || !devicesChanged"
          :class="{ 'no-events' : !devicesChanged }"
          @click="changeUserDevices(), hideModal('changeDevices')">
          Save and Close
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { CHANGE_USER_DEVICES, UNSELECT_USER } from '@/core/services/store/users.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal } from '@/core/utils'
import moment from 'moment'

export default {
  name: 'ModalChangeDevices',
  data() {
    return {
      showModal,
      hideModal,
      moment,

      totalDevices: null,
    }
  },
  computed: {
    ...mapGetters([
      'selectedUser',
      'selectedUserId',
      'usersResponses',
    ]),

    devicesChanged() {
      return this.totalDevices !== this.selectedUser.devices
    },
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    unselectUser() {
      this.$store.commit(UNSELECT_USER)
    },

    applyCurrentDevices() {
      this.totalDevices = this.selectedUser.devices
    },

    clearCurrentDevices() {
      this.totalDevices = null
    },

    changeUserDevices() {
      this.$store.dispatch(CHANGE_USER_DEVICES, {
        id: this.selectedUserId,
        devices: this.totalDevices
      })
    },

    watchForInput(val) {
      if (Number(val) < 1) {
        this.totalDevices = 1
      }
    },
  }
}
</script>
